import alcurtAvatar from '../images/alcurt/alcurt.jpg';
import stk_哭 from '../images/alcurt/stickers/哭.gif';
import stk_嗨 from '../images/alcurt/stickers/嗨.gif';
import stk_害羞 from '../images/alcurt/stickers/害羞.jpg';
import stk_憨憨 from '../images/alcurt/stickers/憨憨.jpg';
import stk_打招呼 from '../images/alcurt/stickers/打招呼.jpg';
import stk_汗 from '../images/alcurt/stickers/汗.jpg';
import stk_生气 from '../images/alcurt/stickers/生气.jpg';
import stk_眠 from '../images/alcurt/stickers/眠.gif';
import stk_问号 from '../images/alcurt/stickers/问号.jpg';

// cx 星言
import cxAvatar from '../images/cx/cx.jpg';
import cx_伤心 from '../images/cx/stickers/伤心.jpg';
import cx_何意味 from '../images/cx/stickers/何意味.jpg';
import cx_你好 from '../images/cx/stickers/你好.gif';
import cx_可爱 from '../images/cx/stickers/可爱.gif';
import cx_咋回事 from '../images/cx/stickers/咋回事.gif';
import cx_坏笑 from '../images/cx/stickers/坏笑.jpg';
import cx_害羞 from '../images/cx/stickers/害羞.jpg';
import cx_怎么了 from '../images/cx/stickers/怎么了.jpg';
import cx_我没意见 from '../images/cx/stickers/我没意见.jpg';
import cx_投降 from '../images/cx/stickers/投降.jpg';
import cx_牛逼 from '../images/cx/stickers/牛逼.jpg';
import cx_鄙视 from '../images/cx/stickers/鄙视.jpg';
import cx_问号 from '../images/cx/stickers/问号.jpg';

/**
 * 人格配置
 *
 * 每个人格定义:
 *   key        - URL 中 ?persona=xxx 的值
 *   name       - 人物名字（顶栏、气泡昵称）
 *   title      - 页面标题（欢迎页、浏览器 tab）
 *   model      - 对应后端 model 参数，路由到不同 API
 *   avatar     - 头像图片
 *   stickers   - { 中文名: 图片 } 贴纸映射，null 表示无贴纸
 *   favicon    - 可选，覆盖浏览器 favicon
 */
const PERSONAS = {
  alcurt: {
    name: 'Alcurt',
    title: 'Alcurt Chat',
    model: 'granite',
    avatar: alcurtAvatar,
    stickers: {
      '哭': stk_哭,
      '嗨': stk_嗨,
      '害羞': stk_害羞,
      '憨憨': stk_憨憨,
      '打招呼': stk_打招呼,
      '汗': stk_汗,
      '生气': stk_生气,
      '眠': stk_眠,
      '问号': stk_问号,
    },
  },

  cx: {
    name: 'cx星言',
    title: '星言 Chat',
    model: 'granite',
    avatar: cxAvatar,
    stickers: {
      '伤心': cx_伤心,
      '何意味': cx_何意味,
      '你好': cx_你好,
      '可爱': cx_可爱,
      '咋回事': cx_咋回事,
      '坏笑': cx_坏笑,
      '害羞': cx_害羞,
      '怎么了': cx_怎么了,
      '我没意见': cx_我没意见,
      '投降': cx_投降,
      '牛逼': cx_牛逼,
      '鄙视': cx_鄙视,
      '问号': cx_问号,
    },
  },
};

/** 从 prop 或路由获取当前人格；无则默认 'alcurt' */
export function getActivePersona(overrideKey) {
  const key = overrideKey || 'alcurt';
  return PERSONAS[key] || PERSONAS.alcurt;
}

/** 获取所有可用人格的 keys */
export function getPersonaKeys() {
  return Object.keys(PERSONAS);
}

/** 按 key 获取人格 */
export function getPersona(key) {
  return PERSONAS[key] || PERSONAS.alcurt;
}

export default PERSONAS;
